export default __webpack_public_path__ + "static/media/nivaldo-1199x1199.072be53d.webp";